import { render, staticRenderFns } from "./Dx.vue?vue&type=template&id=f91a42a6&scoped=true"
import script from "./Dx.vue?vue&type=script&lang=js"
export * from "./Dx.vue?vue&type=script&lang=js"
import style0 from "./Dx.vue?vue&type=style&index=0&id=f91a42a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91a42a6",
  null
  
)

export default component.exports